import Decimal from "decimal.js";
import { BinanceRates } from "../models/binancerates.model";
import { responseHero } from "../utils/axiosInterceptor";

export type ThreeYearChange = {
    startDate: string;
    endDate: string | null;
    startClose: Decimal;
    endClose: Decimal | null;
    pctChange: Decimal | null;
};

export type BTCDataResponse = {
    rates: Pick<BinanceRates, "date" | "closePrice">[],
    rows: ThreeYearChange[],
    min: ThreeYearChange | null,
    max: ThreeYearChange | null
}

export const getBTCData = (): Promise<BTCDataResponse> => {
    return new Promise<BTCDataResponse>((resolve, reject) => {

        responseHero.get(`${process.env.REACT_APP_API_URL}/btcdata`).then((response) => {
            resolve(response.data as BTCDataResponse);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};